import apiWrapper from '../../services/apiWrapper';

const getVisitorLogs = async () => {
  try {
    // Make a GET request to fetch the visitor logs
    const response = await apiWrapper('get', '/visitor-logs');

    // Assuming your backend API returns an array of visitor logs
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    console.error('Error fetching visitor logs:', error.message);
    return {
      success: false,
      message: 'Failed to fetch visitor logs.',
    };
  }
};

export default getVisitorLogs;
